module.exports = __webpack_public_path__ + "media/images/onboarding-3-7c768eb1241a105253438e0b74b8a8d2.jpg";